var _excluded = ["languageButton", "items"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment, useContext, useState } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../contexts/OnColorContext";
import useBreakpoint from "../../../../hooks/useBreakpoint";
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.406 5.784.246 1.258a.675.675 0 0 1 0-1.042.926.926 0 0 1 1.189 0L6 4.22 10.565.216a.926.926 0 0 1 1.189 0 .675.675 0 0 1 0 1.042l-5.16 4.526A.9.9 0 0 1 6 6a.901.901 0 0 1-.594-.216Z"
  }));
};
ArrowDown.defaultProps = {
  width: "12",
  height: "6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../../utils/breakpoint";
import getBorderColor from "../../../../utils/getBorderColor";
import space from "../../../../utils/space";
import transition from "../../../../utils/transition";
import unit from "../../../../utils/unit";
import IconAtm from "../../../atoms/IconAtm";
import RichTextMol from "../../../molecules/RichTextMol";
import FlexContainerOrg from "../../../organisms/FlexContainerOrg";
import PushOrg from "../../../organisms/PushOrg";
var Wrapper = styled.div.withConfig({
  componentId: "sc-1cqy6iz-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:grid;grid-gap:", ";grid-template-areas:\"items\" \"button\";padding-top:", ";border-top:", " solid ", ";", "{> *:last-child{order:-1;}}", "{grid-template-areas:\"button items\";justify-content:space-between;}"], space(7), space(3), unit(1), getBorderColor(theme, $onColor, "low"), breakpoint("small", "medium"), breakpoint("large"));
});
var LanguageButton = styled.button.withConfig({
  componentId: "sc-1cqy6iz-1"
})(["grid-area:button;padding:0;border:0;background:none;text-align:left;cursor:pointer;"]);
export var ArrowIcon = styled(IconAtm).withConfig({
  componentId: "sc-1cqy6iz-2"
})(function (_ref2) {
  var $hasHover = _ref2.$hasHover;
  return css(["", " ", ""], transition("transform"), $hasHover && css(["transform:translateY(", ");"], unit(2)));
});
var ItemsWrapper = styled.div.withConfig({
  componentId: "sc-1cqy6iz-3"
})(["grid-area:items;", "{display:flex;}"], breakpoint("medium"));
var Item = styled.div.withConfig({
  componentId: "sc-1cqy6iz-4"
})(["display:flex;align-items:center;margin-bottom:", ";&:last-child{margin-bottom:0;}", "{margin-bottom:0;}"], space(6), breakpoint("medium"));
var Separator = styled.div.withConfig({
  componentId: "sc-1cqy6iz-5"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["align-self:stretch;width:", ";margin:0 ", ";overflow:hidden;border-left:", " solid ", ";"], unit(1), space(4), unit(1), getBorderColor(theme, $onColor, "low"));
});
function AdditionalFooterMol(_ref4) {
  var languageButton = _ref4.languageButton,
    items = _ref4.items,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var onColor = useContext(OnColorContext);
  var isSmallOnly = useBreakpoint("small", "medium");
  var handleOnMouseEnter = function handleOnMouseEnter() {
    setHover(true);
  };
  var handleOnMouseLeave = function handleOnMouseLeave() {
    setHover(false);
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(LanguageButton, {
    onClick: languageButton.onClick,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(RichTextMol, {
    data: languageButton.title,
    typography: "small3"
  }), /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 1
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    icon: ArrowDown,
    sizeSpace: 2,
    color: languageButton.arrowColor,
    $hasHover: hover
  }))), /*#__PURE__*/React.createElement(RichTextMol, {
    data: languageButton.subtitle,
    typography: "nano1",
    emphasis: "medium"
  })), /*#__PURE__*/React.createElement(ItemsWrapper, null, items.map(function (item, index) {
    var isLastElement = items.length === index + 1;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(PushOrg, {
        rightSpace: 2
      }, item.icon), item.title), !isLastElement && !isSmallOnly && /*#__PURE__*/React.createElement(Separator, {
        $onColor: onColor
      }))
    );
  })));
}
export default AdditionalFooterMol;